import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import { COMPOSER_PATH } from '../routes';
import AuthActions from 'auth/AuthActions';
import CurrentUser from 'auth/CurrentUser';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import LinkConstants from 'constants/LinkConstants';
import MenuItem from 'components/MenuItem';
import ModalMenuItem from 'components/ModalMenuItem';
import NavigationMenu from 'components/NavigationMenu';
import UserAvatar from 'users/components/UserAvatar';
import SupportDialog from 'support/components/SupportDialog';
import Text from 'components/Text';

import './styles/ShareSDKHeader.scss';

const renderMenuItems = () => (
  <NavigationMenu>
    <ModalMenuItem modal={<SupportDialog />}>
      <Glyph name="help" size="large" />
      <FormattedMessage id="navigation.help" defaultMessage="Help center" />
    </ModalMenuItem>
    <MenuItem
      href={LinkConstants.TERMS_OF_SERVICE}
      target="_blank"
      eventElementName="Navigation-account"
      color="graphite"
    >
      <Glyph name="flag" size="large" />
      <FormattedMessage id="navigation.termsOfService" defaultMessage="Terms of Service" />
    </MenuItem>
    <MenuItem
      href={LinkConstants.PRIVACY_POLICY}
      target="_blank"
      eventElementName="Navigation-account"
      color="graphite"
    >
      <Glyph name="caution" size="large" />
      <FormattedMessage id="navigation.privacyPolicy" defaultMessage="Privacy Policy" />
    </MenuItem>
    <MenuItem
      href={LinkConstants.MARKETING}
      target="_blank"
      eventElementName="Navigation-account"
      color="graphite"
    >
      <Glyph name="mobile" size="large" />
      <FormattedMessage id="navigation.getTheApp" defaultMessage="Go to Remind" />
    </MenuItem>
    <MenuItem
      onClick={() => AuthActions.signOut(COMPOSER_PATH + window.location.search)} // dumping back to the composer path to deal with lti flows
      eventElementName="Navigation-logOut"
      color="graphite"
    >
      <Glyph name="sign-out" size="large" />
      <FormattedMessage id="navigation.logout" defaultMessage="Log out" />
    </MenuItem>
  </NavigationMenu>
);

const ShareSDKHeader = () => (
  <div className="ShareSDKHeader-container">
    <div className="ShareSDKHeader-container-brandLink" />
    {CurrentUser.isSignedIn() && (
      <div className="ShareSDKHeader-container-content">
        <div>
          <UserAvatar
            className="ShareSDKHeader-container-content-avatar"
            user={CurrentUser.getUser().toJSON()}
            color="whiteout"
            size="large"
          />
        </div>
        <div className="ShareSDKHeader-container-content-username">
          <LayerTrigger layer={renderMenuItems()} placement="bottom" trigger="click">
            <div>
              <Text truncate size="large" color="whiteout">
                {CurrentUser.getUser().getDisplayName()}
                <Glyph name="chevron-down" size="xsmall" color="whiteout" />
              </Text>
            </div>
          </LayerTrigger>
        </div>
      </div>
    )}
  </div>
);

export default ShareSDKHeader;
